import { cn } from "@/utils/cn";
import { useUpload, UseUploadOptions } from "@/hooks/use-upload";

export interface UploadProps extends UseUploadOptions {
  className?: string;
  dragOverClassName?: string;
  children: React.ReactNode;
}

export const Upload = ({
  className,
  dragOverClassName,
  children,
  ...uploadOptions
}: UploadProps) => {
  const { isDragOver, handlers } = useUpload(uploadOptions);

  return (
    <div
      className={cn(className, isDragOver && dragOverClassName)}
      {...handlers}
    >
      {children}
    </div>
  );
};
